// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__10XCe","legacyBtn":"MutateMid_legacyBtn__2jCTM"};